import {useMutation} from '@tanstack/react-query';
import {apiClient, queryClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {message} from '@common/i18n/message';
import {DatatableDataQueryKey} from '@common/datatable/requests/paginated-resources';
import {Chat} from '../../../chats/chat';
import {useNavigate} from '@common/utils/hooks/use-navigate';
import {UseFormReturn} from 'react-hook-form';
import {onFormQueryError} from '@common/errors/on-form-query-error';

interface Response extends BackendResponse {
   chat: Chat;
}

export interface UpdateChatPayload extends Chat {
  id: number;
}

const Endpoint = (id: number) => `chats/${id}`;

export function useUpdateChat(form: UseFormReturn<UpdateChatPayload>, callback_url: string) {
  const {trans} = useTrans();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: (payload: UpdateChatPayload) => updateChat(payload),
    onSuccess: response => {
      toast(trans(message('Chat updated')));
      queryClient.invalidateQueries({
        queryKey: [Endpoint(response. chat.id)],
      });
      queryClient.invalidateQueries({
        queryKey: DatatableDataQueryKey('chats'),
      });
      navigate(callback_url ? callback_url: '/admin/chats');
    },
    onError: err => onFormQueryError(err, form),
  });
}

function updateChat({
  id,
  ...payload
}: UpdateChatPayload): Promise<Response> {
  const backendPayload = {
    ...payload
  };
  return apiClient.put(Endpoint(id), backendPayload).then(r => r.data);
}
